import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56187fcb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade modal-md",
  id: "ModalUsers",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = {
  class: "modal-content",
  style: {"border-radius":"10px"}
}
const _hoisted_5 = { class: "modal-header p-5" }
const _hoisted_6 = { class: "d-flex gap-4 p-0 align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div style=\"background:rgb(236, 236, 236);\" class=\"p-3 rounded\" data-v-56187fcb><svg width=\"22\" height=\"22\" viewBox=\"0 0 25 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-56187fcb><g clip-path=\"url(#clip0_4339_1347)\" data-v-56187fcb><path opacity=\"0.4\" d=\"M24.3113 6.93848L22.0604 9.18945C21.8309 9.41895 21.4598 9.41895 21.2303 9.18945L15.8104 3.76953C15.5809 3.54004 15.5809 3.16895 15.8104 2.93945L18.0613 0.688477C18.9744 -0.224609 20.4588 -0.224609 21.3768 0.688477L24.3113 3.62305C25.2293 4.53613 25.2293 6.02051 24.3113 6.93848ZM13.8768 4.87305L1.05451 17.6953L0.0193508 23.6279C-0.122251 24.4287 0.575992 25.1221 1.37677 24.9854L7.30939 23.9453L20.1317 11.123C20.3611 10.8936 20.3611 10.5225 20.1317 10.293L14.7117 4.87305C14.4774 4.64355 14.1063 4.64355 13.8768 4.87305ZM6.05939 16.5967C5.79084 16.3281 5.79084 15.8984 6.05939 15.6299L13.5789 8.11035C13.8475 7.8418 14.2772 7.8418 14.5457 8.11035C14.8143 8.37891 14.8143 8.80859 14.5457 9.07715L7.02619 16.5967C6.75763 16.8652 6.32794 16.8652 6.05939 16.5967ZM4.29669 20.7031H6.64044V22.4756L3.49103 23.0273L1.97248 21.5088L2.52423 18.3594H4.29669V20.7031Z\" fill=\"#203972\" data-v-56187fcb></path><path d=\"M13.8768 4.87305L1.05451 17.6953L0.0193508 23.6279C-0.122251 24.4287 0.575991 25.1221 1.37677 24.9854L7.30939 23.9453L20.1317 11.123C20.3611 10.8936 20.3611 10.5225 20.1317 10.293L14.7117 4.87305C14.4774 4.64355 14.1063 4.64355 13.8768 4.87305ZM6.05939 16.5967C5.79083 16.3281 5.79083 15.8984 6.05939 15.6299L13.5789 8.11035C13.8475 7.8418 14.2772 7.8418 14.5457 8.11035C14.8143 8.37891 14.8143 8.80859 14.5457 9.07715L7.02619 16.5967C6.75763 16.8652 6.32794 16.8652 6.05939 16.5967ZM4.29669 20.7031H6.64044V22.4756L3.49103 23.0273L1.97248 21.5088L2.52423 18.3594H4.29669V20.7031Z\" fill=\"#203972\" data-v-56187fcb></path></g><defs data-v-56187fcb><clipPath id=\"clip0_4339_1347\" data-v-56187fcb><rect width=\"25\" height=\"25\" fill=\"white\" data-v-56187fcb></rect></clipPath></defs></svg></div>", 1)
const _hoisted_8 = {
  key: 0,
  class: "m-0 subtitulo cor_texto_1"
}
const _hoisted_9 = {
  key: 1,
  class: "m-0 subtitulo cor_texto_1"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  fill: "#afb7bd",
  widxmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  class: "modal-body d-flex flex-column p-5 gap-5",
  style: {"background":"rgb(249, 249, 249) !important"},
  id: "modalBody"
}
const _hoisted_13 = { class: "d-flex flex-column gap-3 m-0 p-0 col-12" }
const _hoisted_14 = { class: "d-flex flex-column gap-1" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Nome", -1))
const _hoisted_16 = { class: "d-flex flex-column gap-1" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Email", -1))
const _hoisted_18 = {
  key: 0,
  class: "d-flex flex-column gap-1"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Lojas", -1))
const _hoisted_20 = { class: "d-flex flex-column gap-1" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Cargo", -1))
const _hoisted_22 = { class: "d-flex flex-column p-0 m-0 container" }
const _hoisted_23 = { class: "row gap-3 p-0 m-0" }
const _hoisted_24 = { class: "d-flex flex-column gap-1 col p-0" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Documento", -1))
const _hoisted_26 = { class: "d-flex flex-column gap-1 col p-0" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "texto" }, "Telefone", -1))
const _hoisted_28 = { class: "modal-footer d-flex flex-nowrap justify-content-end align-items-center p-5" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 25 25",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_4339_1349)" }, [
    /*#__PURE__*/_createElementVNode("g", { opacity: "0.4" }, [
      /*#__PURE__*/_createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.98438 12.5H21.0938C22.3877 12.5 23.4375 13.5499 23.4375 14.8438V22.6563C23.4375 23.9502 22.3877 25 21.0938 25H3.90625C2.6123 25 1.5625 23.9502 1.5625 22.6563V14.8438C1.5625 13.5499 2.6123 12.5 3.90625 12.5H5.07812H8.98438ZM12.5 21.875C13.5791 21.875 14.4531 21.001 14.4531 19.9219V17.5782C14.4531 16.4991 13.5791 15.625 12.5 15.625C11.4209 15.625 10.5469 16.4991 10.5469 17.5782V19.9219C10.5469 21.001 11.4209 21.875 12.5 21.875Z"
      }),
      /*#__PURE__*/_createElementVNode("path", { d: "M8.98438 12.5V7.46587C8.98438 5.53227 10.5322 3.92583 12.4658 3.9063C14.4189 3.88677 16.0156 5.47368 16.0156 7.42192V8.20317C16.0156 8.85259 16.5381 9.37505 17.1875 9.37505H18.75C19.3994 9.37505 19.9219 8.85259 19.9219 8.20317V7.42192C19.9219 3.32036 16.5771 -0.0146004 12.4756 4.80722e-05C8.37402 0.0146965 5.07812 3.3936 5.07812 7.49517V12.5H8.98438Z" })
    ]),
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.98438 12.5H21.0938C22.3877 12.5 23.4375 13.5498 23.4375 14.8438V22.6562C23.4375 23.9502 22.3877 25 21.0938 25H3.90625C2.6123 25 1.5625 23.9502 1.5625 22.6562V14.8438C1.5625 13.5498 2.6123 12.5 3.90625 12.5H5.07812H8.98438ZM12.5 21.875C13.5791 21.875 14.4531 21.001 14.4531 19.9219V17.5781C14.4531 16.499 13.5791 15.625 12.5 15.625C11.4209 15.625 10.5469 16.499 10.5469 17.5781V19.9219C10.5469 21.001 11.4209 21.875 12.5 21.875Z"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_4339_1349" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "25",
        height: "25"
      })
    ])
  ])
], -1))
const _hoisted_30 = {
  key: 1,
  class: "d-flex gap-3 justify-content-center align-items-center",
  style: {"border":"1.5px solid rgb(219, 219, 219)","border-radius":"8px","padding-right":"12px","width":"fit-content","margin-right":"auto"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" }, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 2,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border sr-only"
}
const _hoisted_36 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  height: "1em",
  viewBox: "0 0 448 512"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  height: "1em",
  viewBox: "0 0 448 512"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z" }, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = {
  key: 1,
  width: "20",
  height: "20",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 416c-35.3 0-64-28.7-64-64s28.7-64 64-64s64 28.7 64 64s-28.7 64-64 64z" }, null, -1))
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tem certeza de que deseja excluir este usuário?", -1))
const _hoisted_55 = { class: "dialog-footer d-flex justify-content-end gap-3" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Tem certeza de que deseja remover este usuário?", -1))
const _hoisted_57 = { class: "dialog-footer d-flex justify-content-end gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                (_ctx.usuario.id)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Editar dados do usuário"))
                  : (_openBlock(), _createElementBlock("p", _hoisted_9, "Adicionar novo usuário"))
              ])
            ]),
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fechaModal())),
              "aria-label": "Close"
            }, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("ul", _hoisted_13, [
              _createElementVNode("li", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.usuario.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.usuario.name) = $event)),
                  placeholder: "Digite..."
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("li", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.usuario.email,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.usuario.email) = $event)),
                  placeholder: "Digite..."
                }, null, 8, ["modelValue"])
              ]),
              (!_ctx.idLoja)
                ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.usuarioLojas,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.usuarioLojas) = $event)),
                      multiple: "",
                      "collapse-tags": "",
                      "collapse-tags-tooltip": "",
                      "max-collapse-tags": 2,
                      filterable: "",
                      placeholder: "selecione uma loja"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayLojas, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.codConcessionaria,
                            label: item.nome,
                            value: item.codConcessionaria
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.usuario.idCargo,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.usuario.idCargo) = $event)),
                  clearable: "",
                  placeholder: "Selecione um cargo..."
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayCargos, (cargo) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: cargo.id,
                        label: cargo.nome,
                        value: cargo.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("ul", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("li", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.usuario.documento,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.usuario.documento) = $event)),
                    maxlength: "14",
                    placeholder: "123.456.789-00",
                    onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.formatarInput('documento', $event)))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("li", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.usuario.telefone,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.usuario.telefone) = $event)),
                    maxlength: "15",
                    onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.formatarInput('telefone',$event))),
                    placeholder: "(12) 34567-8900"
                  }, null, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            (_ctx.usuario.id && !_ctx.clikouResetarSenha)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  variant: "primary",
                  text: "Resetar senha",
                  style: {"min-width":"fit-content"},
                  onClick: _cache[9] || (_cache[9] = () => _ctx.clikouResetarSenha = true)
                }, {
                  default: _withCtx(() => [
                    _hoisted_29
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.usuario.id && _ctx.clikouResetarSenha)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _withDirectives(_createElementVNode("input", {
                    id: "inputSenha",
                    style: {"width":"100px","outline":"none !important"},
                    placeholder: "Senha...",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.novaSenha) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.novaSenha]
                  ]),
                  (!_ctx.loadResetarSenha)
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 0,
                        onClick: _cache[11] || (_cache[11] = () => (_ctx.clikouResetarSenha = false, _ctx.novaSenha = '')),
                        xmlns: "http://www.w3.org/2000/svg",
                        style: {"cursor":"pointer"},
                        height: "1.5em",
                        fill: "#afb7bd",
                        viewBox: "0 0 384 512"
                      }, _hoisted_32))
                    : _createCommentVNode("", true),
                  (!_ctx.loadResetarSenha)
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 1,
                        onClick: _cache[12] || (_cache[12] = () => (_ctx.clikouResetarSenha = false, _ctx.resetarSenha())),
                        xmlns: "http://www.w3.org/2000/svg",
                        style: {"cursor":"pointer"},
                        height: "1.5em",
                        fill: "#F64E60",
                        viewBox: "0 0 448 512"
                      }, _hoisted_34))
                    : _createCommentVNode("", true),
                  (_ctx.loadResetarSenha)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Loading..."))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.idLoja && _ctx.usuario.id)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  type: "button",
                  variant: "primary",
                  text: "Excluir",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.dialogVisible = true))
                }, {
                  default: _withCtx(() => [
                    (_ctx.loadExcluir)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_39, _hoisted_41))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_Button, {
                  key: 3,
                  type: "button",
                  variant: "primary",
                  text: "Remover",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.dialogVisible = true))
                }, {
                  default: _withCtx(() => [
                    (_ctx.loadRemoveUsuario)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_44))
                      : (_openBlock(), _createElementBlock("svg", _hoisted_45, _hoisted_47))
                  ]),
                  _: 1
                })),
            _createVNode(_component_Button, {
              variant: "secondary",
              text: "Salvar",
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.salvaUsuario()))
            }, {
              default: _withCtx(() => [
                (_ctx.loadSave)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_50))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_51, _hoisted_53))
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    (!_ctx.idLoja && _ctx.usuario.id)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.dialogVisible) = $event)),
          title: "Confirme sua ação",
          width: "30%"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_55, [
              _createVNode(_component_Button, {
                type: "button",
                variant: "primary",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.dialogVisible = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancelar")
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                variant: "secondary",
                type: "button",
                onClick: _ctx.deletarUsuario
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Confirmar")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_54
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.dialogVisible,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.dialogVisible) = $event)),
          title: "Confirme sua ação",
          width: "30%"
        }, {
          footer: _withCtx(() => [
            _createElementVNode("span", _hoisted_57, [
              _createVNode(_component_Button, {
                type: "button",
                variant: "primary",
                onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.dialogVisible = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancelar")
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                variant: "secondary",
                type: "button",
                onClick: _ctx.removeLojaUsuario
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Confirmar")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_56
          ]),
          _: 1
        }, 8, ["modelValue"]))
  ]))
}